const config = {
    production: true,
    productionRoot: '/projects/super-tactico',
    staticRoot: '/super-tactico/',
};
module.exports = config;